import { Link, router } from '@inertiajs/react'
import Layout from '../../../components/Layout'

interface Template { id: number; name: string; description: string | null; created_at: string }

export default function ProjectTemplatesIndex({ templates, can_create }: { templates: Template[]; can_create: boolean }) {
  return (
    <Layout>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-semibold" style={{ color: '#1B1B1B' }}>Project Templates</h1>
        <Link href="/projects" className="text-sm text-[#15532E]">← Back to projects</Link>
      </div>
      <div className="bg-white border rounded-lg">
        {templates.length === 0 ? (
          <div className="p-8 text-center text-text-muted">No templates yet. Save a project as a template to see it here.</div>
        ) : (
          <ul>
            {templates.map((t) => (
              <li key={t.id} className="border-b last:border-b-0 px-4 py-3 flex items-center justify-between">
                <div>
                  <Link href={`/project_templates/${t.id}`} className="font-medium text-text-primary hover:underline">{t.name}</Link>
                  {t.description && <p className="text-xs text-text-muted">{t.description}</p>}
                </div>
                <button onClick={() => router.post(`/project_templates/${t.id}/instantiate`)} className="text-xs px-3 py-1.5 rounded text-white" style={{ backgroundColor: '#ED1C24' }}>Use template</button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Layout>
  )
}
